import ValueObject from './ValueObject';

export default class ProjectPhaseId extends ValueObject {
  equals(other) {
    if (!(other instanceof ProjectPhaseId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new ProjectPhaseId(json);
  }
}
